<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-8">
          <strong
            class="card-title mb-3"
          >Percentile Ratios last 10 years</strong>
        </div>
        <div class="col-md-3">
          <download :tableId="'percentile-ratios-10-years'" :fileName="'percentile-'+selectedVal+'-10-years'"></download>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-9 br">
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <input
              class="form-control"
              v-model="searchText"
              placeholder="Search"
              @keyup="filteredList($event)"
            >
          </div>
          <div class="form-group">
            <select class="form-control" v-model="selRangeFilter" @change="filterRangeData($event)">
              <option
                v-for="(d, index) in mcOptions"
                v-bind:key="d.id+index"
                :value="index"
              >{{d.value}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <!-- <mcfilter :rawData="rawData" :searchData="searchData" @updateRawData="updaterdata"> </mcfilter> -->
        </div>
      </div>
      <hr>
      <div class="row mb5">
        <div class="col-md-3">
          <div class="form-group">
            <select class="form-control" name="raw-data" v-model="rawDataType" @change="getRawData">
              <option v-for="(d, index) in rawDataList" v-bind:key="d.id" :value="index">{{d.value}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="table-responsive app" v-dragscroll="true">
        <table
          id="percentile-ratios-10-years"
          class="table table-bordered fonts11 app-inner"
          v-if="rawData.length>0"
        >
          <thead>
            <tr>
              <th>Sr.</th>
              <th
                @click="sortColumn(field, index)"
                style="font-size:.92em"
                class="data-cell column-sort"
                v-for="(field, index, key) in tableFields"
                v-bind:key="'field'+field+index+key"
              >
                {{field.name}}
                <i
                  class="fa fa-caret-down"
                  v-if="(field.sort_order == 1 || field.sort_order == 0)"
                ></i>
                <i
                  class="fa fa-caret-up"
                  v-else-if="(field.sort_order == 2 || field.sort_order == 0)"
                ></i>
              </th>
              <th v-for="year in last10years" :key="'yearth'+year">{{year}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row,index) in rawData" v-bind:key="'row'+row+index">
              <td>{{index+1}}</td>
              <td v-for="field in tableFields" v-bind:key="'td'+field.title+index">
                <span v-if="field.isLink">
                  <a class="a-btn" @click.prevent="showCompDetails(row)">{{ row[field.title]}}</a>
                </span>
                <span v-else>{{(field.isNumeric)? getFixed(row[field.title]): row[field.title]}}</span>
                <!-- {{(field.isNumeric)? getFixed(row[field.title]): row[field.title]}} -->
              </td>
              <td
                v-for="(year,ind) in last10years"
                v-bind:key="'yeartd'+ind"
              >{{getFixed(row[year])}}</td>
            </tr>
          </tbody>
        </table>
        <div class="alert alert-danger" role="alert" v-else>No data found!</div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";

export default {
  props: ["company"],
  mixins: [commonMixins],
  created() {
    if (!localStorage.getItem("perRatio"))
      localStorage.setItem("perRatio", 0);
    else this.rawDataType = parseInt(localStorage.getItem("perRatio"));
    this.getLastTenYears();
    this.getRawData();
  },
  data() {
    return {
      rawDataType: 0,
      tableFields: [],
      rawDataList: [
        {
          id: "pdividend_ratio",
          value: "PDividend Ratio",
          open: true,
          items: {}
        },
        { id: "pe_ratio", value: "PE Ratio", open: false, items: {} },
        {
          id: "pcf_ratio",
          value: "PCF Ratio",
          open: false,
          items: {}
        },
        { id: "pb_ratio", value: "PB Ratio", open: false, items: {} }
      ],
      rawDataApi: "getAllPercentileData",
      rawData: [],
      searchData: [],
      cut_off_ratio: 0,
      searchText: "",
      selectedVal: "",
      selRangeFilter: 0,
      mcOptions: [
        { id: 0, value: "All", min: "", max: "" },
        { id: 1, value: "MC > 20000", min: 20000, max: "" },
        { id: 2, value: "5000 <= MC <= 20000", min: 5000, max: 20000 },
        { id: 3, value: "1000 <= MC <= 5000", min: 1000, max: 5000 },
        { id: 4, value: "MC <= 1000", min: "", max: 1000 }
      ],
      ddate: "", //new Date().setDate(new Date().getDate() - 1)
    };
  },
  methods: {
    getRawData() {
      this.selFilter = "";
      this.rawData = [];
      let myself = this;
      localStorage.setItem("perRatio", this.rawDataType);
      this.tableFields = [
        {
          title: "co_code",
          name: "Company Code",
          isNumeric: false,
          sort_order: 0,
          isLink: 0
        },
        {
          title: "company_name",
          name: "Company",
          isNumeric: false,
          sort_order: 0,
          isLink: 1
        },
        {
          title: "sectorname",
          name: "Sector",
          isNumeric: false,
          sort_order: 0,
          isLink: 0
        },
        {
          title: "marketCapitalization_latest",
          name: "Market Cap (Latest)",
          isNumeric: true,
          sort_order: 0,
          isLink: 0
        },
        // {
        //   title: this.rawDataList[this.rawDataType].id,
        //   name: this.rawDataList[this.rawDataType].value,
        //   isNumeric: true,
        //   sort_order: 0,
        //   isLink: 0
        // }
      ];

      this.selectedVal = this.rawDataList[this.rawDataType].id;
      this.cut_off_ratio = 0;
      http.post(
        this.rawDataApi,
        {
          name: this.rawDataList[this.rawDataType].id
        },
        (error, response) => {
          if (response.length > 0) {
            myself.rawData = response;
            myself.searchData = response;
            myself.ddate = new Date(myself.rawData[0].date);
          }
          // myself.cut_off_ratio = response.cut_off;
        }
      );
    },
    filtDate(obj) {
      console.log("FilterDATE", obj, JSON.stringify(obj));
      this.ddate = new Date(obj.durDate);
      this.selRangeFilter = 0;
      this.searchText = "";
      this.getRawData();
    },
    filterRangeData(event) {
      this.clearData();
      var ind = event.target.value;
      this.selRangeFilter = this.mcOptions[ind].id;
      if (this.selRangeFilter === 0) {
        this.rawData = this.searchData;
        return this.rawData;
      } else {
        var minRange = this.mcOptions[ind].min;
        var maxRange = this.mcOptions[ind].max;
        this.rawData = this.searchData.filter(rd => {
          // console.log(rd, this.selRangeFilter);
          if (minRange != "" && maxRange != "") {
            return (
              parseInt(rd["marketCapitalization_latest"]) >=
                parseInt(minRange) &&
              parseInt(rd["marketCapitalization_latest"]) <= parseInt(maxRange)
            );
          } else {
            if (minRange != "") {
              return (
                parseInt(rd["marketCapitalization_latest"]) >=
                parseInt(minRange)
              );
            }
            if (this.maxRange != "") {
              return (
                parseInt(rd["marketCapitalization_latest"]) <=
                parseInt(maxRange)
              );
            }
          }
        });
      }
      setTimeout(() => {
        this.sortColumn(this.tableFields[2], 2);
      });
    },
    filterData() {
      this.clearData();
      if (this.selFilter !== "") {
        if (this.minRange == "" && this.maxRange == "") {
          this.rawData = this.searchData;
          return this.rawData;
        } else {
          this.rawData = this.searchData.filter(rd => {
            // console.log(rd, this.selFilter);
            if (this.minRange != "" && this.maxRange != "") {
              return (
                parseInt(rd[this.selFilter]) >= parseInt(this.minRange) &&
                parseInt(rd[this.selFilter]) <= parseInt(this.maxRange)
              );
            } else {
              if (this.minRange != "") {
                return parseInt(rd[this.selFilter]) >= parseInt(this.minRange);
              }
              if (this.maxRange != "") {
                return parseInt(rd[this.selFilter]) <= parseInt(this.maxRange);
              }
            }
          });
        }
      }
    },
    filteredList(e) {
      this.selRangeFilter = 0;
      this.selFilter = "";
      if (this.searchText === null || this.searchText === "") {
        this.rawData = this.searchData;
        return this.rawData;
      } else if (this.searchText.length <= 2) {
        this.rawData = this.searchData;
        return this.rawData;
      }
      if (this.searchText.length > 2 || e.keyCode === 13) {
        this.rawData = this.searchData.filter(rd => {
          console.log(rd);
          return (
            rd.co_code.toLowerCase().includes(this.searchText.toLowerCase()) ||
            (rd.company_name
              ? rd.company_name
                  .toLowerCase()
                  .includes(this.searchText.toLowerCase())
              : false) || (rd.sectorname
              ? rd.sectorname
                  .toLowerCase()
                  .includes(this.searchText.toLowerCase())
              : false)
          );
        });
      }
    },
    clearData() {
      this.selRangeFilter = 0;
      this.selFilter = "";
      this.searchText = "";
      this.rawData = this.searchData;
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table th.column-sort {
  cursor: pointer;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/industry/yearwisePercentileRatios.vue